import { storeAuthHeaders } from '@/utils/authentication_headers';

const authenticationResponseInterceptor = (response) => {
  if (response) storeAuthHeaders(response);

  return response;
};

export default [
  authenticationResponseInterceptor,
];



// WEBPACK FOOTER //
// ./src/api/response_interceptors.js